import { authInstance } from "./axios";
let url = process.env.REACT_APP_API_URL;

export const enterpriseService = {
  getFleetLocation: async (params) => {
    const response = await authInstance
      .get(`${url}/enterprise/listForAlliance`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
  createForAlliance: async (data) => {
    const response = await authInstance
      .post(`${url}/enterprise/createForAlliance`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        error.data = [];
        return error;
      });
    return response;
  },
};
